import { render, staticRenderFns } from "./today.vue?vue&type=template&id=1a02bc34&scoped=true"
import script from "./today.vue?vue&type=script&lang=js"
export * from "./today.vue?vue&type=script&lang=js"
import style0 from "./today.vue?vue&type=style&index=0&id=1a02bc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a02bc34",
  null
  
)

export default component.exports